import { useState } from "react";
import {
  Card,
  CardContent,
  Container,
  Grid,
  FormLabel,
  FormGroup,
  OutlinedInput,
} from "@material-ui/core";
import FilterCard from "components/_refactor/filter-card";
import PeriodField from "components/_refactor/fields/period-field";
import StructureFields from "components/_refactor/fields/structure";
import HeaderClientes from "components/_refactor/headers/clients";
import { IsMobile } from "utils/is-mobile";
import BigNumberCard from "components/_refactor/card/big-number";
import TableAcompanhamentoAtendimento from "./components/TableAcompanhamentoAtendimento";
import Api from "lib/api/httpRequestHelper";
import InfoDialog from "./components/dialog-info";
import moment from "moment";
import MaskAndValid from "utils/maskAndValid";

const dataHoje = new Date().toISOString().slice(0, 10);
const data30DiasAtras = moment(dataHoje)
  .subtract(30, "days")
  .format("YYYY-MM-DD");

export default function AcompanhamentoAtendimento() {
  const [structureFilters, setStructureFilters] = useState({});
  const [periodo, setPeriodo] = useState(null);
  const [periodoInicial, setPeriodoInicial] = useState();
  const [periodoFinal, setPeriodoFinal] = useState();
  const [clearFilters, setClearFilters] = useState(false);
  const [cardsData, setCardsData] = useState({
    demandas: 0,
    resolvidos: 0,
    pendentes: 0,
  });
  const [servicesList, setServicesList] = useState([]);
  const [searching, setSearching] = useState(false);
  const [loadingCards, setLoadingCards] = useState(false);
  const [structureLoading, setStructureLoading] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const [cnpj, setCnpj] = useState("");
  const isValidCnpj = cnpj ? MaskAndValid.validateCNPJ(cnpj) : false;
  const cnpjUnmasked = cnpj?.replace(/[^\d]+/g, "");

  const isMobile = IsMobile();
  const itemSM = isMobile ? 12 : 4;

  const handleClearFilters = () => {
    setClearFilters(true);
    setPeriodo(null);
    setPeriodoInicial(null);
    setPeriodoFinal(null);
    setCnpj("");
  };

  const handleSearch = async ({ status }) => {
    setSearching(true);
    handleSearchTotais();
    try {
      const query =
        `?idGrupoEconomico=${structureFilters?.idGrupoEconomico || "TODOS"}` +
        `&idLoja=${structureFilters?.idLoja || "TODAS"}` +
        `&status=${status}` +
        `&dtIni=${periodoInicial}&dtFim=${periodoFinal}` +
        (isValidCnpj ? `&cnpj=${cnpjUnmasked}` : "");

      const response = await Api.get("tiket-detail", "omnireport", query, true);
      setServicesList(response?.Result?.ListaChamados);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setSearching(false);
  };

  const handleSearchTotais = async () => {
    setLoadingCards(true);
    try {
      const query =
        `?idGrupoEconomico=${structureFilters?.idGrupoEconomico || "TODOS"}` +
        `&idLoja=${structureFilters?.idLoja || "TODAS"}` +
        `&dtIni=${periodoInicial}&dtFim=${periodoFinal}` +
        (isValidCnpj ? `&cnpj=${cnpjUnmasked}` : "");

      const response = await Api.get("tiket-total", "omnireport", query, true);
      setCardsData({
        demandas: response?.Result?.TotalDemandas || 0,
        resolvidos: response?.Result?.TotalResolvido || 0,
        pendentes: response?.Result?.TotalPendente || 0,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingCards(false);
  };

  const CARDS_INFO = [
    {
      title: "Demandas",
      value: cardsData.demandas,
      loading: loadingCards,
      legend: "Filtrar por demandas",
      onClick: () => {
        handleSearch({ status: "TODOS" });
      },
    },
    {
      title: "Resolvidos",
      value: cardsData.resolvidos,
      loading: loadingCards,
      legend: "Filtrar por resolvidos",
      onClick: () => {
        handleSearch({ status: "FINALIZADO" });
      },
    },
    {
      title: "Pendentes",
      value: cardsData.pendentes,
      loading: loadingCards,
      legend: "Filtrar por pendentes",
      onClick: () => {
        handleSearch({ status: "ABERTO" });
      },
    },
  ];

  return (
    <div>
      <HeaderClientes
        section="Acompanhamento de Atendimento"
        subsection="Serviços"
      />
      <Container maxWidth={false} style={{ marginTop: "-4rem" }}>
        <FilterCard
          handleSearch={() => handleSearch({ status: "TODOS" })}
          disabled={searching || structureLoading.length > 0}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <StructureFields
            clearFilters={clearFilters}
            onStructureFieldsChange={setStructureFilters}
            disableAll={searching}
            onStructureFieldsLoad={setStructureLoading}
            handleSearch={() => handleSearch({ status: "TODOS" })}
            hideFields={["channel", "representative", "brand"]}
          />
          <Grid item xs={12} sm={4} md={4}>
            <FormGroup>
              <FormLabel>CNPJ</FormLabel>
              <OutlinedInput
                fullWidth
                type="text"
                placeholder="00.000.000/0000-00"
                value={cnpj}
                onChange={(e) => {
                  setCnpj(MaskAndValid.maskCNPJ(e.target.value));
                }}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .toString()
                    .slice(0, 18);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch({ status: "TODOS" });
                  }
                }}
                disabled={searching}
              />
            </FormGroup>
          </Grid>
          <Grid item xs={periodo?.value === "Outros" ? "12" : "3"}>
            <PeriodField
              label="Período"
              value={periodo}
              onChange={setPeriodo}
              initialDate={periodoInicial}
              finalDate={periodoFinal}
              setInitialDate={setPeriodoInicial}
              setFinalDate={setPeriodoFinal}
              disabled={searching}
              required={false}
            />
          </Grid>
        </FilterCard>

        <Card>
          <CardContent>
            <Grid container spacing={2}>
              {CARDS_INFO.map((card, index) => (
                <Grid item xs={itemSM} key={index}>
                  <BigNumberCard
                    title={card.title}
                    value={card.value}
                    loading={card.loading}
                    legend={card.legend}
                    onClick={card.onClick}
                  />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        <TableAcompanhamentoAtendimento
          data={servicesList}
          loading={searching}
          onRowClick={(row) => setSelectedRow(row)}
        />
      </Container>
      {selectedRow && (
        <InfoDialog
          onClose={() => setSelectedRow(null)}
          row={selectedRow}
        />
      )}
    </div>
  );
}
